export const resolveLegacyTimezone = (timezone?: string | null): string | undefined => {
    if (!timezone) {
        return undefined
    }

    return timezone === 'Asia/Almaty' ? 'Asia/Tashkent' : timezone
}
